import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header/Header";

export const Layout = ({ showHeaderPaths = [] }) => {
  const { pathname } = useLocation();
  let portal = pathname.split("/")[1];
  //console.log(portal);
  let z = 0;
  if (portal !== "") {
    z = showHeaderPaths.filter(
      (path) => path.toLowerCase().indexOf(portal.toLowerCase()) > -1
    );
  }
  //console.log(z.length);

  return (
    <>
      {z.length > 0 && <Header />}
      <Outlet />
    </>
  );
};
